export default "__VITE_ASSET__CZQ2sDpl__"